import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, ArrowRight, BookOpen, Heart, GraduationCap, Calendar } from 'lucide-react';

const PROGRAMS = [
  { icon: GraduationCap, name: 'Formação PAREI-AD', desc: 'Curso profissional em 13 módulos', color: '#8b5cf6' },
  { icon: Calendar, name: 'Tratamento 90 Dias', desc: 'Programa de recuperação intensivo', color: '#3b82f6' },
  { icon: Calendar, name: 'Tratamento 180 Dias', desc: 'Acompanhamento estendido', color: '#10b981' },
  { icon: Heart, name: 'Programa Familiar', desc: 'Apoio para familiares — 90 dias', color: '#f472b6' },
];

export default function CourseStandbyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" style={{ background: 'linear-gradient(180deg, #06061a 0%, #0c0c2d 50%, #0a0a1a 100%)' }} data-testid="course-standby-page">
      <div className="max-w-lg mx-auto text-center">
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', stiffness: 200 }} className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center" style={{ background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.3)' }}>
          <BookOpen className="h-10 w-10 text-amber-400" />
        </motion.div>

        <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="text-2xl sm:text-3xl font-bold text-white mb-3">
          Estamos preparando algo profundo para você
        </motion.h1>

        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }} className="text-sm text-gray-400 mb-8 max-w-md mx-auto leading-relaxed">
          Os programas e tratamentos estão em fase final de construção e em breve estarão disponíveis exclusivamente para assinantes Premium.
        </motion.p>

        {/* Programs preview */}
        <div className="space-y-3 mb-8">
          {PROGRAMS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div key={i} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 + i * 0.1 }} className="flex items-center gap-3 p-3 rounded-xl text-left" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: `${p.color}15` }}>
                  <Icon className="h-5 w-5" style={{ color: p.color }} />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-white">{p.name}</p>
                  <p className="text-xs text-gray-500">{p.desc}</p>
                </div>
                <Lock className="h-4 w-4 text-gray-600 flex-shrink-0" />
              </motion.div>
            );
          })}
        </div>

        <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8 }} whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} onClick={() => navigate('/premium')} className="px-8 py-4 rounded-xl text-base font-bold text-white inline-flex items-center gap-2" style={{ background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)' }} data-testid="standby-premium-btn">
          Ativar Premium <ArrowRight className="h-5 w-5" />
        </motion.button>

        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 0.5 }} transition={{ delay: 1 }} className="text-xs text-gray-600 mt-4">
          Você será notificado assim que os programas estiverem disponíveis
        </motion.p>
      </div>
    </div>
  );
}
